var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StdTable"},[_c('table',{staticClass:"StdTable__table"},_vm._l((_vm.content),function(row,rowIndex){return _c('tr',{key:rowIndex,staticClass:"StdTable__row"},_vm._l((row),function(cell,cellIndex){return _c('TableCell',{key:cellIndex,attrs:{"heading":cell.heading,"content":cell.text,"rowspan":cell.rowspan,"colspan":cell.colspan}})}))}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7481e993","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StdTable/StdTable.vue
// module id = null
// module chunks = 